import React, { useEffect, useState } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import { Link, useNavigate } from 'react-router-dom';
import { Center, Container, Stack, Heading, Text, Button } from '@chakra-ui/react';
import getUrlParams from '../../services/getUrlParams';
import { SuccessModal } from '../../components/Modals';
import { QuestionnaireHeader } from '../../components/Form';
import Loader from '../../components/Feedback/Loader';
import {
 QuestionnaireTable,
 CertificationsTable,
 UserTable,
} from '../../components/Tables';
import { fetchData } from '../../services/fetch';
import { normalizeCompanyData } from '../../helpers/company-utils';
import CompanyRegisterForm from '../../components/CompanyForm';

const defaultFields = [
 {
  cnpj: '',
  name: '',
  fantasyname: '',
  phone: '',
  address: '',
  admin: {
   username: '',
   email: '',
  },
  cnae_list: [],
  newField: true,
 },
];

export default function Companie() {
 const navigate = useNavigate();
 const { companyRegister } = getUrlParams();
 const [idCompanyGroup, setIdCompanyGroup] = useState(null);
 const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);

 const { mutate } = useSWRConfig();

 const {
  data: companyData,
  isLoading: companyDataIsLoading,
  error: companyDataError,
 } = useSWR(companyRegister ? `/company/${companyRegister}` : null, fetchData);

 const { data: groupSurveys, isLoading: groupSurveysIsLoading } = useSWR(
  companyRegister ? `/company/linkSurveyCompany/${companyRegister}` : null,
  fetchData
 );

 const initialValues = companyRegister
  ? normalizeCompanyData(companyData)
  : defaultFields;

 const handleSuccess = () => {
  setSuccessModalIsOpen(true);
  mutate(`/company/${companyRegister}`);
 };

 useEffect(() => {
  if (companyData) {
   const groupId =
    companyData?.idCompanyGroup || companyData?.companies?.[0]?.idCompanyGroup;
   if (groupId && !idCompanyGroup) {
    setIdCompanyGroup(groupId);
   }
  }
 }, [companyData, idCompanyGroup]);

 const closeSuccessAndReturn = () => {
  setSuccessModalIsOpen(false);
  mutate(`/company/?cr=`)
  navigate('/registration');
 };

 useEffect(() => {
  if (companyDataError) {
   navigate('/registration');
  }
 }, [companyDataError]);

 if (companyDataIsLoading || groupSurveysIsLoading) {
  return <Loader />;
 }

 const companyName = Array.isArray(companyData?.companies)
  ? companyData?.companies?.[0]?.c_name
  : companyData?.c_name;

 return (
  <Container maxW='100vw' minH='100vh' overflowX='hidden' p={0}>
   <QuestionnaireHeader
    tagLabel='Empresas'
    heading={companyRegister ? companyName : 'Cadastrar Empresa'}
   >
    <Stack spacing='12px' display={['none', 'flex']} justify='center'>
     <Button
      as={Link}
      to='/registration'
      variant='cancel'
      size='medium'
      w='200px'
      mt='50px'
     >
      Voltar
     </Button>
    </Stack>
   </QuestionnaireHeader>

   <Center
    py={['8px', '32px']}
    px={{ xl: '86px', '2xl': 'unset' }}
    alignItems='start'
    minH='90vh'
    bg='#EEE'
   >
    <Container bg='white' maxW={'1280px'} p='24px' borderRadius='12px'>
     <Heading fontSize='20px' lineHeight='24.8px' mb='16px'>
      Informações da empresa
     </Heading>
     <Text fontSize='sm' lineHeight='20px' mb='32px'>
      Insira o CNPJ da empresa e caso seja válido, todos os dados serão preenchidos.
      <br />
      Não se esqueça de adicionar responsáveis.
     </Text>

     <Stack spacing='32px' overflow='hidden'>
      <CompanyRegisterForm
       idCompanyGroup={idCompanyGroup}
       isFreemium={companyData?.isFreemium}
       formsList={groupSurveys}
       initialValues={initialValues}
       handleSuccess={handleSuccess}
       companyRegister={companyRegister}
      />

      <QuestionnaireTable
       groupSurveys={groupSurveys}
       companyRegister={companyRegister}
       idCompanyGroup={idCompanyGroup}
       mutate={mutate}
      />

      <CertificationsTable
       formsList={[]}
       companyRegister={companyRegister}
       idCompanyGroup={idCompanyGroup}
       mutate={mutate}
      />

      <UserTable companyRegister={companyRegister} idCompanyGroup={idCompanyGroup} />
     </Stack>
    </Container>
   </Center>

   <SuccessModal
    isOpen={successModalIsOpen}
    onClose={closeSuccessAndReturn}
    title={
     companyRegister
      ? 'Suas alterações foram salvas com sucesso'
      : 'Empresa cadastrada com sucesso'
    }
   />
  </Container>
 );
}
